import React, { useState } from 'react';
import AsyncSelect from 'react-select/async';
import { ErrorMessage } from 'formik';

import { formStyles } from '../../constants/SiteVariables';
import { getIndustryTypes } from '../../actions/industries';

export default function StickyIndustryTypeAhead({
  id,
  placeholder,
  setFieldValue,
}) {
  const [selectedOption, setSelectedOption] = useState();

  const style = {
    control: base => ({
      ...base,
      height: '60px !important',
      borderColor: '#ABB4BE !important',
      padding: '0.5rem 0 !important',
      borderRadius: '6px',
    }),
    placeholder: base => ({
      ...base,
      paddingTop: '7.5px'
    }),
    input: base => ({
      ...base,
      paddingTop: '7.5px'
    }),
    valueContainer: base => ({
      ...base,
      paddingTop: '8.5px',
      paddingLeft: '9px'
    })
  };

  const loadOptions = async (inputValue, callback) => {
    if (inputValue && inputValue.length > 1) {
      const response = await getIndustryTypes(inputValue);
      callback(response.data.map(i => ({
        id: i.id,
        value: i.attributes.code,
        label: i.attributes.description,
      })));
    }
  }

  const onChangeSelectedOption = (e) => {
    const selectedOption = e.id;
    setFieldValue('industry', e.id)
    setSelectedOption(selectedOption);
  };

  return (
    <div className='sticky-type-ahead is-fullwidth'>
      <AsyncSelect
        id={id}
        name={id}
        value={selectedOption?.id}
        onChange={onChangeSelectedOption}
        loadOptions={loadOptions}
        defaultOptions={false}
        placeholder='Begin search by typing...'
        className='async-type-ahead'
        styles={style}
      />
      <label className="placeholder" htmlFor={id}>{placeholder}</label>
      <ErrorMessage name={id} component="div" className={formStyles.validation} />
    </div>
  );
}
